import { FormSelectYesNo } from '../../formelements'
//import { enguanyAnyVinent } from '../../../utils'

//const {enguany, anyVinent} = enguanyAnyVinent()

export const AuthDretsImatgeCompostMajors18 = (props) => 
{

    return ( <>

    <div className="row">
        <div className="col col-12 ">
        <h4>
            Autorització relativa a l’alumnat major d'edat i del personal docent i no docent
            del centre: ús d’imatges, publicació de dades de caràcter personal i de material
            que elaboren. 
        </h4>
        <p>
            El centre disposa d’espais de comunicació i difusió, inclosos els espais web (adreça
            o adreces web), on informa i fa difusió de les activitats escolars lectives,
            complementàries i extraescolars. En aquests espais es poden publicar
            imatges/veu en què aparegui, individualment o en grup, alumnat i
            personal docent que fa les activitats esmentades. El dret a la pròpia imatge és
            reconegut en l’article 18.1 de la Constitució espanyola i està regulat per
            la Llei orgànica 1/1982, de 5 de maig, sobre el dret a l’honor, a la intimitat
            personal i familiar i a la pròpia imatge, per la qual cosa la direcció d’aquest
            centre demana el consentiment per publicar fotografies i vídeos on surti alumnat i
            personal docent que hi sigui clarament identificable.
        </p>

        <p>
            Autoritzo mentre mantingui vinculació amb el centre
        </p>

        <p>
            Que la meva imatge/veu pugui sortir en fotografies i/o vídeos corresponents a
            activitats escolars lectives, complementàries i extraescolars
            organitzades pel centre i publicades en: 
            
        </p>
        </div>
    </div>


    <div className="row">
        <div className="col col-12 ">
        <FormSelectYesNo
            id="authIntranet"
            name="authIntranet"
            col="col-6"
            label="Intranet amb accés restringit:"
            obligatori={true}
            value={props.authIntranet}
            handleChange={(e) => props.setAuthIntranet(e.target.value) }
            error={props.errors.authIntranet}
        />

        <FormSelectYesNo
            id="authInternet"
            name="authInternet"
            col="col-6"
            label="Internet amb accés no restringit"
            obligatori={true}
            value={props.authInternet}
            handleChange={(e) => props.setAuthInternet(e.target.value) } 
            error={props.errors.authInternet}
        />
        </div>
    </div>

    </>)
}

export const AuthDretsImatgeCompostMenors18 = (props) => 
{

    return ( <>

    <div className="row">
        <div className="col col-12 ">
        <h4>
            Autorització relativa a l'ús d’imatges, publicació de dades de caràcter personal i sobre l'ús de serveis i recursos digitals a Internet per treballar a l'aula
        </h4>
        <p>
            <b>Període de validesa:</b> Mentre l'alumne/a estigui matriculat al centre educatiu i no canviïn les circumstàncies de l'alumne referides en aquest document.
        </p>
        <p>
            El centre disposa d’espais de comunicació i difusió, inclosos els espais web (adreça
            o adreces web), on informa i fa difusió de les activitats escolars lectives,
            complementàries i extraescolars. En aquests espais es poden publicar
            imatges/veu en què aparegui, individualment o en grup, alumnat i
            personal docent que fa les activitats esmentades. El dret a la pròpia imatge és
            reconegut en l’article 18.1 de la Constitució espanyola i està regulat per
            la Llei orgànica 1/1982, de 5 de maig, sobre el dret a l’honor, a la intimitat
            personal i familiar i a la pròpia imatge, per la qual cosa la direcció d’aquest
            centre demana el consentiment per publicar fotografies i vídeos on surti alumnat i
            personal docent que hi sigui clarament identificable.
        </p>

        <p>
            Autoritzo:
        </p>

        <br/>

        <p>
            Que la imatge/veu del meu fill/a pugui sortir en fotografies i/o vídeos corresponents a
            activitats escolars lectives, complementàries i extraescolars organitzades pel centre i publicades en: 
            
        </p>
        </div>
    </div>

    <div className="row">
        <div className="col col-12 ">
        <FormSelectYesNo
            id="authIntranet"
            name="authIntranet"
            col="col-6"
            label="Intranet amb accés restringit: (Plataformes administrades pel centre: Weeras, Moodle, G Suite, etc.)"
            obligatori={true}
            value={props.authIntranet}
            handleChange={(e) => props.setAuthIntranet(e.target.value) }
            error={props.errors.authIntranet}
        />

        <FormSelectYesNo
            id="authInternet"
            name="authInternet"
            col="col-6"
            label="Internet amb accés no restringit (Web i xarxes socials pròpies del centre: Instagram, Twitter/X, Facebook, Youtube)"
            obligatori={true}
            value={props.authInternet}
            handleChange={(e) => props.setAuthInternet(e.target.value) } 
            error={props.errors.authInternet}
        />
        </div>
    </div>

    </>)
}



/*

export const AuthDretsImatgeMenors14 = ({auth, handleChange, error }) => 
{

    return (
    <>
    <div className="row">
        <div className="col col-12 ">
        <h4>
            Autorització als alumnes menors de 14: Drets d’imatge. Curs {enguany}-{anyVinent}
        </h4>
        <p>
        El pare, mare, tutor/a legal o alumne/a menor de 14 anys autoritza que l'alumne/a pugui aparèixer en imatges i/o vídeos, 
        es publiqui el seu nom, així com material elaborat per l'alumne/a corresponents a activitats escolars lectives, complementàries 
        i extraescolars organitzades pel centre, i publicades a la pàgina web del centre, o revistes, o publicacions editades pel 
        centre, així com les seves xarxes socials.
        </p>
        </div>
    </div>

    <div className="row">
        <div className="col col-12 ">
        <FormSelectYesNo
            id="authDretsImatge"
            name="authDretsImatge"
            col="col-4"
            label="Drets d'Imatge:"
            obligatori={true}
            value={auth}
            handleChange={(e) => handleChange(e.target.value) }
            error={error}
        />
        </div>
    </div>
    </>
    )
}


export const AuthDretsImatgeMenors18 = ({auth, handleChange, error }) => 
{
    return 
        (<div className="row">
            <div className="col col-12 ">
            <h4>
                Drets d'imatge
            </h4>
            <p>
                <input type="checkbox" 
                id="authDretsImatge" 
                name="authDretsImatge" 
                value={ auth } 
                checked={ auth === "1" ? true : false } 
                onChange={ (t) => { handleChange(t.target.value) } 
                }/>

                <label htmlFor="authDretsImatge">
                AUTORITZO que la imatge i/o veu de l'alumne/a matriculat/ada pugui aparèixer en fotografies i vídeos corresponents a 
                les activitats lectives, complementàries, extraescolars i de promoció i difusó organitzades per l'institut i publicades a pàgines WEB,
                xares socials, filmacions no comercials o revistes i publicacions d'àmbit educatiu.
                    </label>
                <span id="auhtDretsImatge_ERROR" className="a-Form-error">{error}</span>
                </p>
        </div>
        </div>)
}

export const AuthDretsImatge = ({auth, handleChange, error }) => 
{

    return 
        (<div className="row">
            <div className="col col-12 ">
            <h4>
                Drets d'imatge
            </h4>
            <p>
                <input type="checkbox" 
                id="authDretsImatge" 
                name="authDretsImatge" 
                value={auth } 
                checked={auth === "1" ? true : false } 
                onChange={ (t) => { handleChange(t.target.value) } 
                }/>

                <label htmlFor="authDretsImatge">
                AUTORITZO que la meva imatge i/o veu pugui aparèixer en fotografies i vídeos corresponents a 
                les activitats lectives, complementàries, extraescolars i de promoció i difusó organitzades per l'institut i publicades a pàgines WEB,
                xares socials, filmacions no comercials o revistes i publicacions d'àmbit educatiu.
                    </label>
                <span id="auhtDretsImatge_ERROR" className="a-Form-error">{error}</span>
                </p>
        </div>
        </div>)
}


*/